import {load} from '@shopify/theme-sections';
import '@/sections/product';
import productDetailAccordion from '@/scripts/product-detail-accordion';
import productLifestyleCarousel from '@/scripts/product-lifestyle-carousel';

load('*');

document.addEventListener('DOMContentLoaded', () => {
  productDetailAccordion();
  productLifestyleCarousel();
});